<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="goodsinfo" style="margin: 20px 0px 0px 20px;">
					<!-- <el-form-item label="商品ID" class='tiny'>
						<el-input style="width:300px;" v-model="goodsinfo.id" placeholder="请输入商品ID">
						</el-input>
					</el-form-item>
					<el-form-item label="供应商名称" class='tiny' cleartable>
						<el-select v-model="goodsinfo.storeId" placeholder="请选择供应商名称">
							<el-option v-for="item in storeList" :key="item.id" :value="item.id"
								:label="item.storeName">
							</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="商品名称" class='tiny'>
						<el-input style="width:300px;" v-model="goodsinfo.goodsName" placeholder="请输入商品名称">
						</el-input>
					</el-form-item>
					<el-form-item label="指导价" class='tiny'>
						<el-input style="width:150px;" v-model="goodsinfo.priceStart" placeholder="最小价">
						</el-input>
						<span style="margin:0 20px;">---</span>
						<el-input style="width:150px;" v-model="goodsinfo.priceEnd" placeholder="最大价">
						</el-input>
					</el-form-item>
					<el-form-item label="商品分类" style="width: 100%;">

						<el-select clearable v-model="classGoods1Id" placeholder="请选择分类" style="margin-right:10px;"
							@change="classGoods1" filterable>
							<el-option clearable v-for="item in classGoods1List" :key="item.id" :label="item.className"
								:value="item.id">
							</el-option>
						</el-select>

						<el-select clearable v-model="classGoods2Id" placeholder="请选择二级分类"
							style="width:30%;margin:0px 10px;" @change="classGoods2">
							<el-option v-for="item in classGoods2List" :key="item.id" :label="item.className"
								:value="item.id">
							</el-option>
						</el-select>

						<el-select clearable v-model="classGoods3Id" placeholder="请选择三级分类"
							style="width:30%;margin:0px 10px;" @change="classGoods3">
							<el-option v-for="item in classGoods3List" :key="item.id" :label="item.className"
								:value="item.id">
							</el-option>
						</el-select>

					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" @click="empty">清空</el-button>
						</template>
					</el-form-item>
			
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->

		<el-row style="width: 100%;">
			<el-col :span="4" v-for="(item, index) in expressList" :key="index"
				style="padding: 10px;width: 20%;height: 400px;margin-bottom: 50px;">

				<el-card :ref="'card'+index"
					:body-style="{borderRadius:'10px', padding: '20px',height:'360px' ,background:'white',color:'black'}"
					shadow="hover">
					<div @mouseenter.prevent="changeflag(index)" @mouseleave.prevent="moveflag(index)"
						style="position: absolute;width: 16%;height: 200px">
						<img :src="item.images.split(',')[0]" class="image" @click="godetail(item.id)">
						<div :ref="'button'+index"
							style="opacity: 0;;display: flex;justify-content: space-between;margin: 0 10px;position: relative;top: 0px;">

							<el-button style="background: rgb(18,98,211);color: white;" @click="godetail(item.id)">查看详情
							</el-button>
							<el-button style="background: rgb(18,98,211);color: white;" @click="addnum(item)">加入选品
							</el-button>
						</div>
						<div style="">
							<!-- <span style="font-size: 14px;">{{item.goodsName}}</span> -->
							<div class="bottom clearfix">
								<span class="time">{{item.goodsName}}</span>

							</div>
							<div class="price">
								<div class="prices" style="border-right: 1px dashed  rgb(227,227,227);">
									<span>协议价：</span> </br>
									<span style="color: red;">￥{{item.agreementPrice}}</span>
								</div>
								<div class="prices">
									<span> 利润率：</span></br>
									<span style="color: red;">{{((item.price-item.agreementPrice)/item.price*100).toFixed(2)+'%'}}</span>
								</div>
							</div>
							<div :ref="'pc'+index" style="display: flex;justify-content: center;opacity: 0;">
								<div class="pricess" style="border-right: 1px dashed  rgb(227,227,227);">
									<span>指导价：</span> </br>
									<span style="font-size: 12px;color: green;">￥{{(item.price).toFixed(2)}}</span>
								</div>
								<div class="pricess" style="border-right: 1px dashed  rgb(227,227,227);">
									<span>最小利润：</span> </br>
									<span
										style="font-size: 12px;color: green;">￥{{(item.price-item.agreementPrice).toFixed(2)}}</span>
								</div>
								<div class="pricess" style="border-right: 1px dashed  rgb(227,227,227);">
									<span>折扣：</span> </br>
									<span
										style="font-size: 12px;color: green;">{{((item.agreementPrice)/(item.price)).toFixed(1)}}</span>
								</div>

							</div>
						</div>
					</div>

				</el-card>
			</el-col>
		</el-row>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
	:page-size='20'
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" title="添加物流公司" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="编号">
						<el-input type="text" style="width: 300px; margin-left:25px ;" v-model="storeGoodsInfo.code"
							auto-complete="off" placeholder="请输入编号" />
					</el-form-item>
					<el-form-item label="公司名称">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.expressName"
							auto-complete="off" placeholder="请输入公司名称" />
					</el-form-item>

					<el-form-item label="公司网址">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.url" auto-complete="off"
							placeholder="请输入公司网址" />
					</el-form-item>
					<el-form-item label="是否启用" class="redItem">
						<el-switch v-model="storeGoodsInfo.isEnable" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<el-button type="primary" @click="submit">提交</el-button>

				</el-form>
			</div>
		</el-dialog>
		<!-- 编辑修改 -->
		<el-dialog :visible.sync="dialogVisibleSwipers" title="编辑修改" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="编号">
						<el-input type="text" style="width: 300px; margin-left:25px ;" v-model="storeGoodsInfo.code"
							auto-complete="off" placeholder="请输入编号" />
					</el-form-item>
					<el-form-item label="公司名称">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.expressName"
							auto-complete="off" placeholder="请输入公司名称" />
					</el-form-item>

					<el-form-item label="公司网址">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.url" auto-complete="off"
							placeholder="请输入公司网址" />
					</el-form-item>
					<el-form-item label="是否启用" class="redItem">
						<el-switch v-model="storeGoodsInfo.isEnable" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
					<el-button type="primary" @click="submitClick">提交</el-button>

				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 20,
				},
				expressList: [],
				goodsinfo: {},
				storeGoodsInfo: {},
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false,
				currentDate: new Date(),
				sliderlist: {},
				flag: false,
				classGoods1List: [],
				classGoods2List: [],
				classGoods3List: [],
				classGoods1Id: "",
				classGoods2Id: "",
				classGoods3Id: "",
				storeList: [],
				orderType:''
			}
		},
		methods: {
			//选中一级分类
			classGoods1(e) {
				// console.log(e)
				this.classGoods2Id = "";
				this.classGoods3Id = "";
				this.classGoods3List = {};
				this.classGoods1Id = e


				this.goodsinfo.classId = e
				if (e) {
					this.$api.goodsClassfindByPid({
						pid: e
					}).then((res) => { //商品三级分类
						if (res.state == 'success') {
							this.classGoods2List = res.data;
						}
					})
				}
			},
			//选中二级分类
			classGoods2(e) {
				// console.log(e)
				this.goodsinfo.classIdOne = e
				this.classGoods3Id = "";
				this.classGoods2Id = e
				this.classGoods3List = {};
				if (e) {
					this.$api.goodsClassfindByPid({
						pid: e
					}).then((res) => { //商品三级分类
						if (res.state == 'success') {
							this.classGoods3List = res.data;
						}
					})
				}
			},
			//选中三级分类
			classGoods3(e) {
				// console.log(e)
				this.goodsinfo.classIdTwo = e
				let obj = {};
				this.classGoods3Id = e

			},
			addnum(item) {
				let data = {
					goodsId: item.id,
					price: item.price
				}
				this.$api.addGood(data).then(res => {
					// console.log(res);
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						this.$message({
							message: res.message,
							type: 'error'
						});
					}
				})
			},
			godetail(id) {
				// console.log(id);
				this.$router.push({
					path: '/goodsdetail?id='+id,
					
				})

			},
			moveflag(index) {

				let a = 'card' + index
				let b = 'pc' + index
				let c = 'button' + index
				this.$refs[a][0].$el.classList.value = ''
				this.$refs[b][0].style.opacity = 0
				this.$refs[c][0].style.opacity = 0
				// console.log(this.$refs[b][0].$el.classList.value);
			},
			changeflag(index) {
				let c = 'button' + index
				let a = 'card' + index
				this.$refs[a][0].$el.classList.value = 'active'
				this.$refs[c][0].style.opacity = 1
				// console.log(this.$refs[a][0].$el.classList.value);
				let b = 'pc' + index
				this.$refs[b][0].style.opacity = 1
				this.flag = !this.flag
			},
			search() { //查询
				if(this.goodsinfo.priceEnd){
					this.orderType = 4
					this.page.pageNum = 1;
					this.sysExpressList()
				}else{
					this.orderType = 3
					this.page.pageNum = 1;
					
					this.sysExpressList()
				}
				
				

			},
			empty() { //清空
				this.goodsinfo = {}
				this.classGoods1Id=''
				this.classGoods2Id=''
				this.classGoods3Id=''
			},
			addDialogClose() {
				// console.log('aaa')

				this.storeGoodsInfo = {}
			},
			sysExpressList() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					orderType:this.orderType,
					...this.goodsinfo
				}
				this.$api.findGoods(this.$encrypt(data)).then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
			addCarousel() {
				this.dialogVisibleSwiper = true

			},

			// 提交
			submit() {
				let data = this.storeGoodsInfo
				// console.log(data)
				this.$api.addExpressList(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.sysExpressList()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},

			// 编辑
			editialogVisible(e) {
				this.$api.findSliderInfo(e).then((res) => {
					if (res.state == 'success') {
						this.storeGoodsInfo = res.data
						this.storeGoodsInfo.isEnable = !res.data.isEnable
						this.dialogVisibleSwipers = true
					}
				})

			},
			// 编辑修改提交
			submitClick() {
				let data = this.storeGoodsInfo
				this.$api.editExpressList(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwipers = false
						this.sysExpressList();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},
			// 删除
			toDelete(e) {
				// console.log(e)
				var str = "此操作将删除该轮播, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.delSliderInfo(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.sysExpressList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.sysExpressList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.sysExpressList()
			},
			getStoreList() {
				this.$api.getStoreList(this.$encrypt({
					storeType: 0
				})).then(res => {
				res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.storeList = res.data.list;
					}
				})
			}
		},




		created() {
			this.sysExpressList()
			this.$api.goodsClassfindByPid({
				pid: 0
			}).then((res) => { //商品一级分类
				if (res.state == 'success') {
					this.classGoods1List = res.data;
				}
			})
			this.getStoreList()
		}
	}
</script>

<style scoped="lang">
	.time {
		font-size: 12px;
		color: black;
		width: 30px;
		font-weight: 600;
	
	}

	.bottom {
		width: 200px;
	
		margin-bottom: 10px;
		margin-top: 10px;
		line-height: 12px;
	}

	.button {
		padding: 0;
		float: right;
	}

	.image {
	width: auto; max-width: 100%; 
		height: 100%;
		display: block;
		margin-left: 12px;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both
	}

	.price {
		border-top: 1px dashed rgb(227, 227, 227);
		display: flex;
		justify-content: space-between;
	}

	.prices {
		width: 50%;
		font-size: 14px;
		margin-top: 20px;
		font-weight: 600;
		text-align: center;
	}

	.pricess {
		width: 50%;
		font-size: 14px;
		margin-top: 20px;
		font-weight: 500;
		text-align: center;
		color: #7f7f7f;
	}

	.active {
		border: 1px solid red;
		height: 440px !important;
		color: black;
		background: white;
		border-radius: 10px;
	}
</style>
